import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2
} from "@angular/core";
import { Observable } from "rxjs";

import {
  GrowlNotice,
  GrowlNoticeType
} from "@lantern/app/core/utils/growl-service/growl-notice";

import { GrowlContainerComponent } from "./growl-container.component";

@Component({
  selector: "ta-growl-notice",
  templateUrl: "./growl-notice.component.html"
})
export class GrowlNoticeComponent implements OnInit, OnDestroy {
  @Input()
  get notice(): GrowlNotice {
    return this._notice;
  }
  set notice(value: GrowlNotice) {
    if (value === this._notice) {
      return;
    }
    this._notice = value;
    this.setNoticeIcon();
    this.setModifierHostClass();
  }
  private _notice: GrowlNotice;

  expirationObservable: Observable<GrowlNotice>;

  get growlType(): GrowlNoticeType {
    return this.notice != null ? this.notice.type : "info";
  }

  constructor(
    private elementRef: ElementRef,
    private growlContainerComponent: GrowlContainerComponent,
    private renderer2: Renderer2
  ) {
    this.initBaseHostClass();
  }

  private expirationTimeout?: any;
  ngOnInit(): void {
    this.expirationTimeout = setTimeout(
      () => this.close(),
      this.notice.duration || 4000
    );
    this.setNoticeIcon();
  }

  ngOnDestroy(): void {
    if (this.expirationTimeout != null) {
      clearTimeout(this.expirationTimeout);
    }
  }

  setNoticeIcon(): void {
    if (this.notice.icon != null) {
      return;
    }

    switch (this.notice.type) {
      case "success":
        this.notice.icon = "ok-circled";
        break;
      case "info":
        this.notice.icon = "info-circled";
        break;
      case "warning":
        this.notice.icon = "attention";
        break;
      case "danger":
        this.notice.icon = "attention-circled";
        break;
      default:
        return;
    }
  }

  @HostListener("mousedown")
  close(): void {
    this.growlContainerComponent.removeNotice(this.notice);
  }

  private initBaseHostClass(): void {
    this.renderer2.addClass(
      this.elementRef.nativeElement,
      "growl-container__notice"
    );
  }

  private modifierHostClass: string | undefined;
  private setModifierHostClass(): void {
    if (this.modifierHostClass != null) {
      this.renderer2.removeClass(
        this.elementRef.nativeElement,
        this.modifierHostClass
      );
    }
    this.modifierHostClass = `growl-container__notice--${this.growlType}`;
    this.renderer2.addClass(
      this.elementRef.nativeElement,
      this.modifierHostClass
    );
  }
}
